import { SessionType } from '../analytics.service';
import { AnalyticsEvent } from './analytics-event';

export class SessionAction {
  actionString = '';
  reason = '';
  constructor() {}
  created() {
    this.actionString = 'created';
    return this;
  }
  deleted(reason: string) {
    this.actionString = `deleted`;
    this.reason = reason;
    return this;
  }
}
export class SessionEvent implements AnalyticsEvent {
  eventName = '';
  params: Map<string, any> = new Map<string, any>();
  constructor(action: SessionAction, type: SessionType, id: string) {
    const params: { [key: string]: string } = {
      type: type.toString(),
      id,
    };
    if (action.actionString === 'deleted') {
      params.reason = action.reason;
    }
    this.eventName = action.actionString;
    this.params.set(type.toString(), id);
  }
}
